import React from 'react';
import {Platform, TextInput} from 'react-native';
import {KeyboardExtendedInput} from 'react-native-external-keyboard';

const KeyboardInput = React.forwardRef<any, any>((props, ref) => {
  const Component = Platform.OS === 'web' ? TextInput : KeyboardExtendedInput;

  return <Component ref={ref} {...props} />;
});

export default KeyboardInput;
